// extracted by mini-css-extract-plugin
export default {"documentIcon":"_7122aac320db063b","icon":"bd5186e9515ae18a","tinyButton":"b42c7754ec530947","block":"f9781d4840ea4ca3"};